module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/cbs-logo/cbs-logo.component.scss
// module id = ./src/app/shared/cbs-logo/cbs-logo.component.scss
// module chunks = main